import StringUtil from '@leverege/string-util'

function getReadableLabel( label ) {
  let readableLabel = ''
  switch ( label ) {
    case 'safety':
      readableLabel = 'Safety'
      break
    case 'product':
      readableLabel = 'Inventory'
      break
    case 'unsupervisedDog':
      readableLabel = 'Unsupervised Dog'
      break
    case 'inventoryHole':
      readableLabel = 'Inventory Hole'
      break
    case 'misplacedProduct':
      readableLabel = 'Misplaced Product'
      break
    case 'personFell':
      readableLabel = 'personFell'
      break
    case 'person':
      readableLabel = 'People'
      break
    case 'dog':
      readableLabel = 'Dogs'
      break
    default:
      readableLabel = StringUtil.capitalize( label )
      break
  }
  return readableLabel
}

export default getReadableLabel
